export default __webpack_public_path__ + "static/discord-cc59f4a291dd7ad9367fc4d4445171bf.png";